import styled, { css } from 'styled-components';

import { TransparentButton } from '@libs/components';

import { DropdownIcon } from 'src/assets';

type NetworkItemProps = {
  isLarge?: boolean;
  isSelected?: boolean;
};
export const NetworkItemWrapper = styled(TransparentButton)<NetworkItemProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  padding: ${({ isLarge }) => (isLarge ? '1.4rem 1.2rem' : '1.6rem')};

  background-color: ${({ theme, isSelected }) =>
    isSelected
      ? theme.colors.interactive.secondary
      : theme.colors.surface.interactiveDefault};
  border-radius: ${({ theme }) => theme.borderRadius.x3};
  border: 0.1rem solid
    ${({ theme, isLarge, isSelected }) => {
      const borderColorDependOnSize = isLarge
        ? theme.colors.surface.interactiveDefault
        : theme.colors.borders.default;
      return isSelected
        ? theme.colors.interactive.brandColor
        : borderColorDependOnSize;
    }};
`;

export const NetworkItemContainer = styled.div<NetworkItemProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${({ isLarge }) =>
    isLarge
      ? css`
          padding: 0 1.2rem;
        `
      : css``}
  width: 100%;
`;

export const ArrowIcon = styled(DropdownIcon)`
  width: 2.4rem;
`;

export const NetworkItemFooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.background.quaternary};
  border-radius: ${({ theme }) => theme.borderRadius.x3};
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  padding: 1.2rem;
  margin-top: 1.6rem;
`;

export const NetworkItemFooterTextWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Separator = styled.div`
  width: 100%;
  height: 0.1rem;

  margin: 1.2rem 0;

  background-color: ${({ theme }) => theme.colors.borders.default};
`;
